import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { catchError, map, throwError } from 'rxjs';
import { apiBaseUrl } from '../config/api.config';
import { ApiError, isApiErrorEnvelope } from '../models/errors/api-error.model';

const ECOMMERCE_URL_PREFIX = `${apiBaseUrl}/api/v1/ecommerce`;

/**
 * Traduce l'envelope `{ ok: false, error: {...} }` in un `ApiError` lanciato.
 *
 * Il contratto ecommerce trasporta gli errori applicativi con HTTP 200, quindi
 * senza questo interceptor ogni `try/catch` dell'applicazione vedrebbe un
 * successo: il checkout cancellerebbe il carrello per un ordine mai creato e lo
 * step cliente avanzerebbe su un salvataggio mai avvenuto.
 *
 * Va registrato DOPO `ecommerceBearerInterceptor`, così l'errore tradotto risale
 * fino a lui e la sessione può essere invalidata quando serve.
 */
export const ecommerceApiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(ECOMMERCE_URL_PREFIX)) {
    return next(req);
  }

  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse && isApiErrorEnvelope(event.body)) {
        throw new ApiError(event.body.error, event.status, event.body.cart);
      }
      return event;
    }),
    catchError((error: unknown) => {
      // I 5xx usano lo stesso envelope ma conservano lo status reale: si
      // normalizzano nello stesso `ApiError` per non avere due formati a valle.
      if (error instanceof HttpErrorResponse && isApiErrorEnvelope(error.error)) {
        return throwError(() => new ApiError(error.error.error, error.status, error.error.cart));
      }
      return throwError(() => error);
    })
  );
};
